import styles from './ButtonOutlined.module.css';

interface Props {
    children: string;
}

export const ButtonOutlined = ({ children }: Props) => {
    return <button className={styles.button}>{children}</button>;
};
